import { Component, Inject, OnDestroy, OnInit, Injector, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalService } from '@app/shared/services/modal.service';
import { Observable, takeUntil } from 'rxjs';
import { SubscriberComponent } from '../subscriber/base/subscriber.component.base';
import { IDynamicDialogConfig } from './model';

@Component({
  selector: 'app-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.sass'],
})
export class DynamicDialogComponent extends SubscriberComponent implements OnInit, OnDestroy {
  acceptButtonTitleDisabled = false;
  loading$: Observable<boolean>;
  componentInjector: Injector;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDynamicDialogConfig,
    private readonly modalSvc: ModalService,
    private readonly dialogRef: MatDialogRef<DynamicDialogComponent>,
    private readonly injector: Injector,
    private readonly cdr: ChangeDetectorRef
  ) {
    super();
    this.loading$ = this.modalSvc.modalLoading$;
    // Crear un injector personalizado que incluye los datos del modal
    this.componentInjector = Injector.create({
      providers: [{ provide: 'MODAL_DATA', useValue: this.data }],
      parent: this.injector,
    });
  }

  ngOnInit() {
    this.acceptButtonTitleDisabled = this.data?.modalComponentData?.acceptButtonTitleDisabled || false;

    this._subscriptions.sink = this.modalSvc
      .getModalData()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => {
          this.data = data;
          this.acceptButtonTitleDisabled = data?.modalComponentData?.acceptButtonTitleDisabled || false;
          this.cdr.detectChanges();
        },
      });
  }

  onAccepted() {
    this.modalSvc.loading(true);
    this.modalSvc.onClickPrimaryAction(true);
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
